import { connect } from 'react-redux';
import * as routes from 'app/routes';

import ConfirmInsurance from 'insurance/ConfirmInsurance/bypassed';
import InsuranceConfirm from './InsuranceConfirm';

const mapStateToProps = (state) => ({
  ConfirmInsurance,
  insurancePlanRoute: routes.bypassedInsurancePlan
});

export default connect(
  mapStateToProps,
  null
)(InsuranceConfirm);
